module.exports = __webpack_public_path__ + "img/parking.60342770.svg";